import styled from 'styled-components'

export const LottieImg = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
`

export const ImageContainer = styled.div`
  width: 50%;
  margin-left: auto;
  margin-right: auto;
`

export const CenterContainer = styled.div`
  text-align: center;
`

export const RedirectLink = styled.a`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.grey80};
  border-bottom: 1px dotted ${({ theme }) => theme.grey80};
  &:hover {
    color: ${({ theme }) => theme.grey100};
    text-decoration: none;
    cursor: pointer;
  }
`
